<!--MOBILE FILTER-->
<div class="addoverlay" [ngClass]="{ overlay: showOverlay}" ></div>

<div class="hidelg">
  <div class="mobile-filter-wrp uk-flex">
    <div class="m-filter" (click)="expandMenu('filter')">
      <!--<img src="assets/images/icons/filter-1.png" alt="" class="icon">-->
      <i class="fa fa-filter" aria-hidden="true"></i>&nbsp;
      <span class="selected-text open-filtermenu cursor-pointer">Filter By</span>
    </div>
    <div class="m-sort" (click)="expandMenu('sort')">
     <!-- <img src="assets/images/icons/sort.png" alt="" class="icon">-->
      <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>&nbsp; 
      <span class="selected-text open-sortmenu cursor-pointer">Sort by</span>
    </div>

    <!--SORT HAMBURGER-->
    <div class="sort-by-hamburger hidelg" [ngClass]="[ expandMobileSortByFilter ? 'filter-hamburger-menu-left' : '']">
      <div class="close-btn">
        <button class="uk-modal-close-default close-sortby" (click)="closeFilterMenu()" type="button" uk-close></button>
      </div>

      <div class="content mt-4">
        <p>Sort by</p>
        <div class="custom-checkbox-wrp">
          <div class="checkbox-group custom-checkbox mb-2" *ngFor="let sort_option of sortBy">
            <input id="sort_{{sort_option.id}}" (change)="onSortBySelect($event)" name="sort_mobile" type="radio" value="{{sort_option.id}}">
            <label for="sort_{{sort_option.id}}" class="input-helper input-helper--checkbox">
              <span>{{sort_option.label}}</span>
            </label>
          </div>
          <!--checkbox-group-->
        </div>
        <div class="btn-group mt-3 hidelg  hideMobile">
          <button (click)="applyFilter()" class="btn-yellow mr-10">Apply</button>
        </div>
      </div>

    </div>
    <!--sort-by-hamburger-->

    <div class="filter-hamburger hidelg" [ngClass]="[ expandMobileFilter ? 'filter-hamburger-menu-left' : '']">
      <div class="close-btn">
        <button class="uk-modal-close-default close-filterby" (click)="closeFilterMenu()" type="button" uk-close></button>
      </div>
      <div class="m-filter-tab-wrp uk-flex">
        <div class="uk-width-100">
          <ul class="uk-tab-left" uk-tab="connect: #component-tab-left; animation: uk-animation-fade">
            <li><a href="#">Location</a></li>
            <li><a href="#">Price</a></li>
          </ul>
        </div>
        <div class="uk-width-expand">
          <ul id="component-tab-left" class="uk-switcher">
            <li>
              <div class="content">
                <div class="custom-checkbox-wrp">
                  <div class="checkbox-group custom-checkbox mb-2" *ngFor="let location of locations">
                    <input [(ngModel)]="location.isSelected" id="location_{{location.id}}_mobile" type="checkbox" (change)="onLocationSelect($event)" value="{{location.id}}">
                    <label for="location_{{location.id}}_mobile" class="input-helper input-helper--checkbox">
                      <span>{{location.sub_locality}}</span>
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="content">
                <div class="custom-checkbox-wrp">
                  <div class="checkbox-group custom-checkbox mb-2" *ngFor="let price of priceRange">
                    <input [(ngModel)]="price.isSelected" id="price_{{price.ranges.min}}-{{price.ranges.max}}_mobile" (change)="onPriceSelect($event)" type="checkbox" value="{{price.ranges.min}}-{{price.ranges.max}}">
                    <label for="price_{{price.ranges.min}}-{{price.ranges.max}}_mobile" class="input-helper input-helper--checkbox">
                      <span><i class="fa fa-rupee"></i> {{price.ranges.min}} - <i class="fa fa-rupee"></i> {{price.ranges.max}}</span>
                    </label>
                  </div>
                  <!--checkbox-group-->
                </div>
              </div>
              <!--content-->
            </li>
          </ul>
        </div>
      </div>
      <div class="filter-btn">
        <div class="btn-group uk-flex uk-flex-right">
          <button class="btn-yellow mr-10" (click)="applyFilter()" type="button">Apply</button>
          <button class="btn-default" (click)="clearFilter()" type="button">Clear All</button>
        </div>
      </div>
    </div>

  </div>
  <!--mobile-filter-wrp-->
</div>
<!--hidelg-->
<!--FILTER-->
<section class="filter-wrp mt-3 bg-white hideMobile" uk-sticky="offset: 50">
  <div class="container">
    <div class="uk-flex uk-flex-middle filter-wrp-inner uk-flex-between position-relative">

      <div class="left-panel uk-flex uk-flex-middle">

        <div class="filter-text uk-flex uk-flex-middle filter-body">
          <!--<img src="assets/images/icons/filter-1.png" alt="" class="icon">-->
          <i class="fa fa-filter" aria-hidden="true"></i>&nbsp;
          <span class="selected-text">Filter By</span>
        </div>

        <div class="select-location filter-body ">

          <button class="uk-flex uk-flex-middle openoverlay" (click)="expandMenu('d_location', $event.target)" type="button">
            <!--<img src="assets/images/icons/location-black.png" alt="" class="icon">-->
            <i class="fa fa-map-marker"></i>&nbsp;
            <span class="selected-text">Location</span>
           <!-- <img src="assets/images/icons/arrow-bottom-2.png" alt="">-->
            <i class="fa fa-angle-down f20" aria-hidden="true"></i>
          </button>


          <div uk-dropdown="mode: click" class="filter-dropdown-body uk-dropdown-bottom-left" [ngClass]="[expandDesktopLocationFilter?'uk-open' :'' ]">
            <div class="dropdown-card">
              <div class="uk-flex uk-flex-right close-dropdown">
                <img src="assets/images/icons/close.png" alt="" class="close-x" (click)="closeFilterMenu()">
              </div>

              <div class="dropdown-card-content">
                <form class="uk-search uk-search-default filter-search w-100">
                  <span uk-search-icon>
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                  <input class="uk-search-input" type="search" placeholder="Search here" (keyup)="searchLocation($event)">
                </form>
                <div class="content">
                  <div class="custom-checkbox-wrp mt-2 customscroll">
                    <div class="checkbox-group custom-checkbox mb-2" *ngFor="let location of locations">
                      <input [(ngModel)]="location.isSelected" id="location_{{location.id}}_desktop" type="checkbox" (change)="onLocationSelect($event)" value="{{location.id}}">
                      <label for="location_{{location.id}}_desktop" class="input-helper input-helper--checkbox">
                        <span>{{location.sub_locality}}</span>
                      </label>
                    </div>
                  </div>
                  <div class="btn-group mt-4">
                    <button class="btn-default btn-yellow mr-10" (click)="applyFilter()" type="button">Apply</button>
                    <button class="btn-default" (click)="clearFilter('location')" type="button">Clear All</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!--select-location-->

        <div class="select-price filter-body">
          <button class="uk-flex uk-flex-middle openoverlay" (click)="expandMenu('d_price')" type="button">
           <!-- <img src="assets/images/icons/rupees.png" alt="" class="icon">-->
           <i class="fa fa-rupee" aria-hidden="true"></i>&nbsp;
         
            <span class="selected-text">Price</span>
            <!--<img src="assets/images/icons/arrow-bottom-2.png" alt="">-->
            <i class="fa fa-angle-down f20" aria-hidden="true"></i>
            
          </button>

          <div uk-dropdown="mode: click" class="filter-dropdown-body uk-dropdown-bottom-left" [ngClass]="[ expandDesktopPriceFilter ? 'uk-open' : '']">
            <div class="dropdown-card">
              <div class="uk-flex uk-flex-between uk-flex-middle close-dropdown">
                <p>Price Range</p>
                <img src="assets/images/icons/close.png" alt="" class="close-x" (click)="closeFilterMenu()">
              </div>
              <div class="dropdown-card-content">
                <div class="content">
                  <div class="custom-checkbox-wrp mt-2 customscroll">
                    <div class="checkbox-group custom-checkbox mb-2" *ngFor="let price of priceRange">
                      <input [(ngModel)]="price.isSelected" id="price_{{price.ranges.min}}-{{price.ranges.max}}_desktop" type="checkbox" (change)="onPriceSelect($event)" value="{{price.ranges.min}}-{{price.ranges.max}}">
                      <label for="price_{{price.ranges.min}}-{{price.ranges.max}}_desktop" class="input-helper input-helper--checkbox">
                        <span><i class="fa fa-rupee"></i> {{price.ranges.min}} - <i class="fa fa-rupee"></i> {{price.ranges.max}}</span>
                      </label>
                    </div>
                  </div>
                  <div class="btn-group mt-4">
                    <button (click)="applyFilter()" class="btn-yellow mr-10 close-dropdown">Apply</button>
                    <button class="btn-default" (click)="clearFilter('price_range')" type="button">Clear All</button>
                  </div>
                </div>
                <!--content-->
              </div>
            </div>
          </div>
          <!--uk-dropdown-->

        </div>
        <!--select-price-->


      </div>
      <!--left-panel-->


      <div class="right-panel select-sort filter-body">
        <button class="sort-card uk-flex uk-flex-middle openoverlay" (click)="expandMenu('d_sort')" type="button">
          <!--<img src="assets/images/icons/sort.png" alt="" class="icon">-->
          <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>&nbsp;  
          <span class="selected-text">Sort by</span>
        </button>

        <div uk-dropdown="mode: click" class="filter-dropdown-body"  [ngClass]="[ expandDesktopSortByFilter ? 'uk-open' : '']">
          <div class="dropdown-card">
            <div class="uk-flex uk-flex-between uk-flex-middle close-dropdown">
              <p>Sort by</p>
              <img src="assets/images/icons/close.png" alt="" class="close-x" (click)="closeFilterMenu()">
            </div>
            <div class="dropdown-card-content">
              <div class="content">
                <div class="custom-checkbox-wrp mt-2 customscrollx">
                  <div class="checkbox-group custom-checkbox mb-2" *ngFor="let sort_option of sortBy">
                    <input id="sort_{{sort_option.id}}_desktop" (change)="onSortBySelect($event)" type="radio" name="sort_dektop" value="{{sort_option.id}}">
                    <label for="sort_{{sort_option.id}}_desktop" class="input-helper input-helper--checkbox">
                      <span>{{sort_option.label}}</span>
                    </label>
                  </div>
                  <!--checkbox-group-->
                  <!--checkbox-group-->
                </div>
                <div class="btn-group mt-3 hidelg hideMobile">
                  <button (click)="applyFilter()" class="btn-yellow mr-10">Apply</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--uk-dropdown-->

      </div>
      <!--right-panel-->

    </div>
  </div>
</section>
